(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('platform195Tracking', platform195Tracking);

    function platform195Tracking() {
        return {
            restrict: 'A',
            scope: '@',
            hotel: '=',
            link($scope, $el) {

                const el = $el[0];
                const button = el.querySelector('.sc-c-button');
                const titleLink = el && el.querySelector('h4 a');
                const { Id, IsSponsoredEstab, ImpressionUrl, ClickUrl, ConversionUrl } = $scope.hotel;
                const estabId = Id;
                const isSponsoredEstab = IsSponsoredEstab;
                const impressionUrl = ImpressionUrl;
                const clickUrl = ClickUrl;
                const conversionUrl = ConversionUrl;
                const hotelId = estabId;

                const generatePixel = url => {
                    if (!url) {
                        return;
                    }
                    const img = new Image();
                    img.src = url;
                    return img;
                };

                // Impression pixel tracking
                impressionUrl && generatePixel(impressionUrl);

                const setConversionPixel = ({ isSponsoredEstab, conversionUrl, hotelId }) => {
                    if (!isSponsoredEstab && !conversionUrl && !hotelId) {
                        return;
                    }
                    const conversionPixelSerialized = JSON.stringify({ isSponsoredEstab, conversionUrl, hotelId });
                    const conversionData = localStorage.setItem(`platform195Conv${hotelId}`, conversionPixelSerialized);
                    return conversionData;
                };


                // for the estab page pill
                const setPlatform195Estab = ({ isSponsoredEstab, hotelId }) => {
                    if (!isSponsoredEstab && !hotelId) {
                        return;
                    }
                    const serialized = JSON.stringify({ hotelId });
                    const platform195Estab = localStorage.setItem(`platform195Estab${hotelId}`, serialized);
                    return platform195Estab;
                };

                // for the estab page pill maybe change to a loop
                const isPlatform195Estab = { isSponsoredEstab, hotelId };
                const platform195EstabEnabled = isSponsoredEstab && hotelId;

                // for the conversion pixel
                const convPixelEnabled = conversionUrl && isSponsoredEstab && hotelId;
                const conversionUrlSettings = {
                    isSponsoredEstab,
                    conversionUrl,
                    hotelId
                };

                const handleClick = () => {
                    clickUrl && generatePixel(clickUrl);
                    convPixelEnabled && setConversionPixel(conversionUrlSettings);
                    platform195EstabEnabled && setPlatform195Estab(isPlatform195Estab);
                };

                button && button.addEventListener('click', handleClick);
                titleLink && titleLink.addEventListener('click', handleClick);
            }
        };
    }
})();
